export default __webpack_public_path__ + "static/media/twitch.3702a1b0.svg";